import {parse} from 'date-fns';
import {ptBR} from 'date-fns/locale';

import {translations} from 'presentation/translations-new';
import {calendarEventFormatter} from 'presentation/modules/myAppointments/utils/calendarEventFormatter';
import {useHostName} from 'presentation/hooks';
import {AppointmentsHomeStateType} from 'presentation/pages/private/home/types';
import {BookingTypeEnum} from '../../constants/bookingTypeEnum';
import {TELEMEDICINE_INFO} from '../../constants/telemedicineInfo';

const {formatEvent} =
	translations['pt-br'].privateFlow.myAppointments.myAppointmentDetails.appointmentInstructions;

export function useCalendarEvent(appointment: AppointmentsHomeStateType) {
	const {dataHostNameState} = useHostName();
	const isTelehealth = appointment.bookingType === BookingTypeEnum.TELEHEALTH;

	const splittedAddress = appointment.formattedAddress.split(' - ');
	const addressForMaps = `${splittedAddress[0]} - ${splittedAddress[1]}`;

	const appointmentEventTitleByHost =
		formatEvent.appointmentEventTitlePart1 +
		dataHostNameState.productName +
		formatEvent.appointmentEventTitlePart2;

	const appointmentEvent = calendarEventFormatter({
		eventTitle: appointmentEventTitleByHost,
		specialty: appointment.specialtyName,
		date: parse(appointment.date, 'P HH:mm', new Date(), {locale: ptBR}),
		providerName: appointment.clinicName,
		specialistName: appointment.providerName,
		address: isTelehealth ? TELEMEDICINE_INFO.name : addressForMaps,
		isTelehealth: appointment.bookingType === BookingTypeEnum.TELEHEALTH,
	});

	return appointmentEvent;
}
